import { useQuery } from "@apollo/client";
import { VehicleTypeResponse, GET_ALL_VEHICLE_TYPES} from "../graphql/queries/getAllVehicleTypes";

interface VehicleTypeOption {
    label: string;
    value: number;
}

export const useVehicleTypes = () => {
    const { data, loading, error } = useQuery<VehicleTypeResponse>(GET_ALL_VEHICLE_TYPES);
    return {
        vehicleTypes: data?.allVehicleTypes,
        loading,
        error
    };
};

// 获取车型选项（英文展示）
export const useVehicleTypeOptions = () => {
    const { vehicleTypes } = useVehicleTypes();
    if (!vehicleTypes) return [];
    return vehicleTypes.map((vehicleType): VehicleTypeOption => ({
        label: vehicleType.nameEn,
        value: vehicleType.id
    }));
};

// 获取英文车型选项
export const useVehicleTypeEnOptions = () => {
    const { vehicleTypes } = useVehicleTypes();
    return vehicleTypes?.map((vehicleType): VehicleTypeOption => ({
        label: vehicleType.nameEn,
        value: vehicleType.id
    })) || [];
};